import produce from 'immer';
import { ActionTypes } from './translator.actions';

export const initialState = {
};
const reducer = (state = initialState, action) => produce(state, (draft) => {
    switch (action.type) {
        case ActionTypes.translationsFetched: {
            const { code, translations } = action.payload;
            draft[code] = translations;
            return draft;
        }
        default: {
            return state;
        }
    }
});
export default reducer;
